import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { detailsForID } from "../actions";
import styles from "./Details.module.css";

export default function Details() {
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(detailsForID(id));
  }, [dispatch, id]);

  const allRecipes = useSelector((state) => state.details);

  return (
    <div className={styles.div}>
      {allRecipes.length > 0 ? (
        typeof allRecipes[0].id === "number" ? (
          <div>
            <li>
              <h1>{allRecipes[0].name}</h1>
            </li>
            <img src={allRecipes[0].image} alt="img not found" />
            <li>
              <h2>Tipo de plato: <br /> {allRecipes[0].dishTypes}</h2>
            </li>
            <li>
              <h3>Dietas: <br /> {allRecipes[0].diets}</h3>
            </li>
            <li>
              <h4>Nivel de comida saludable: <br /> {allRecipes[0].healthScore}</h4>
            </li>
            <li>
              <p>
                Resumen: <br />
                {allRecipes[0].summary.replace(/<[^>]*>/g, '')}
              </p>
            </li>
            <li>
              <p>
                Paso a paso: <br />
                {allRecipes[0].steps[0] && allRecipes[0].steps[0].map(el=>el.steps)}
              </p>
            </li>
          </div>
        ) : (
          <div>
            <h1>{allRecipes[0].name}</h1>
            <img
              src="https://st2.depositphotos.com/3682225/7526/v/950/depositphotos_75266221-stock-illustration-hot-meal-cup-steamy-bowl.jpg"
              width="300px"
              height="300px"
            />
            <h5> Nivel de comida saludable: <br /> {allRecipes[0].healthScore}</h5>
            <h5>Paso a paso: <br /> {allRecipes[0].step}</h5>
            <h5>{allRecipes[0].diets.map((el) => el.name)}</h5>
            <h5>Resumen: <br /> {allRecipes[0].summary}</h5>
          </div>
        )
      ) : (
        <div className={styles.p}>
          <p>...Loading</p>
        </div>
      )}
    </div>
  );
}
